// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"5be24aac","331":"6a2b8507","453":"c70883a4","677":"c29be895","764":"2f7e9a4e","795":"94f5acd1","846":"3f92f0ee"}[chunkId] + ".chunk.js";
};